import classNames from 'classnames';

import LogoMark from './fotofunken-logo-200x200.png';
import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

// Fork-eigener Ersatz für Logtos LogtoSignature (Branding-Entfernung ist
// Cloud-exklusiv, siehe hideLogtoBranding-Guard in core).
const PoweredByFotofunken = ({ className }: Props): JSX.Element => (
  <p className={classNames(styles.poweredBy, className)}>
    Powered by <img src={LogoMark} alt="" /> Fotofunken
  </p>
);

export default PoweredByFotofunken;
